import React, { Component } from "react";

import { rangeMapper, clamp } from "../Utils/Functions";
import { Leds } from "./Leds";
import ModelSpecs from "./ModelSpecs";

export default class Hero extends Component {
  render() {
    const { language, campaignHasEnded } = this.props;

    return (
      <>
        <div
          className="modelBg bg"
          style={{ backgroundImage: 'url("./assets/images/background.png")' }}
        >
          {/* <div className="bg--pattern" style={{
            backgroundImage: 'url("./assets/images/poly.svg")',
            //backgroundPositionY: this.state.scrollTop,
          }}></div>  */}
          <div className="heroWrapper">
            <picture className="heroBackground" alt="Hero">
              {language !== "et" ? (
                <React.Fragment>
                  <source
                    media="(max-width: 640px)"
                    srcSet={"./assets/images/hero_campaign_mobile_rus.jpg"}
                  />
                  <source
                    media="(min-width: 640px)"
                    srcSet={"./assets/images/hero_campaign_ru.png"}
                  />
                  <img src={"./assets/images/hero_campaign_ru.png"} alt="hero" />
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <source
                    media="(max-width: 640px)"
                    srcSet={"./assets/images/hero_campaign_mobile.jpg"}
                  />
                  <source
                    media="(min-width: 640px)"
                    srcSet={"./assets/images/hero_campaign.png"}
                  />
                  <img src={"./assets/images/hero_campaign.png"} alt="hero" />
                </React.Fragment>
              )}
            </picture>

            <div className="heroGradient"></div>
          </div>
          {campaignHasEnded ? (
            <h2
              className="campaignEndHeader"
              style={{
                transform: ` rotate(-10deg)`,
              }}
            >
              {language === "et"
                ? "Kampaania on lõppenud"
                : "Кампания завершилась"}
            </h2>
          ) : (
            ""
          )}
          <div className="offscreen"></div>
        </div>
      </>
    );
  }
}
